
export default {
  data() {
    return {

    }
  },
  created() {
  },
  watch: {
    // indata: {
    //   deep: true,
    //   handler(){
    //     this.tab_data = {...this.indata}
    //   }
    // },
    tab_data: {
      deep: true,
      handler(){
        this.$emit('input', this.tab_data)
      }
    }
  },
  mounted(){
    this.tab_data = {...this.indata}
    this.$root.$on('form-m-loaded', (data)=>{
      this.tab_data = data
    })
  },
  methods: {
    page_change(val1,val2){
      this.$emit('change',val1,val2)
    },
  }
}
